import axios from 'axios'
import { getFirebaseIdToken } from './token'

const BASE_URL = process.env.VUE_APP_EMAIL_REPORT_API_URL

async function authHeaders () {
  const token = await getFirebaseIdToken()
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  }
}

export async function getReportConfig () {
  const headers = await authHeaders()
  const response = await axios.get(`${BASE_URL}/config`, { headers })
  return response.data
}

export async function getSubscriptions (companyId) {
  const headers = await authHeaders()
  const response = await axios.get(`${BASE_URL}/subscriptions`, { headers, params: { companyId } })
  return response.data
}

export async function createSubscription (data) {
  const headers = await authHeaders()
  const response = await axios.post(`${BASE_URL}/subscriptions`, data, { headers })
  return response.data
}

export async function updateSubscription (id, data) {
  const headers = await authHeaders()
  const response = await axios.put(`${BASE_URL}/subscriptions/${id}`, data, { headers })
  return response.data
}

export async function deleteSubscription (id) {
  const headers = await authHeaders()
  await axios.delete(`${BASE_URL}/subscriptions/${id}`, { headers })
}

export async function getSubscriptionJobs (subscriptionId) {
  const headers = await authHeaders()
  const response = await axios.get(`${BASE_URL}/subscriptions/${subscriptionId}/jobs`, { headers })
  return response.data
}
